import { useEffect, useRef, useState } from 'react';

type Props<T> = {
  items: T[];
  getNode: (item: T) => HTMLElement | null;
};

export const usePreserveScrollWhenLoadingPreviousElements = <T>({
  items,
  getNode,
}: Props<T>): T | undefined => {
  const previousNbItems = useRef<number>(items.length);
  const [itemToScrollTo, setItemToScrollTo] = useState<T>();

  if (items.length > previousNbItems.current) {
    if (previousNbItems.current > 0) {
      const nbNewlyGames = items.length - previousNbItems.current;
      setItemToScrollTo(items[nbNewlyGames]);
    }
    previousNbItems.current = items.length;
  }

  useEffect(() => {
    if (itemToScrollTo) {
      getNode(itemToScrollTo)?.scrollIntoView({
        block: 'start',
        behavior: 'instant',
      });
    }
  }, [getNode, itemToScrollTo]);

  return itemToScrollTo;
};
